import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../context/AuthContext';
import { apiFetch, extractArray } from '../lib/api';

/**
 * Shared cached hook for CRM accounts (companies).
 * Stays fresh for 5 minutes, cached for 10 minutes after unmount.
 * Any page that needs accounts (Inbox, Accounts, etc.) gets instant data after first load.
 */
export function useAccounts(options = {}) {
    const { getAuthHeader } = useAuth();
    const { pageSize = 500, enabled = true } = options;

    return useQuery({
        queryKey: ['accounts', { pageSize }],
        queryFn: async () => {
            const data = await apiFetch(`/accounts?page_size=${pageSize}`, getAuthHeader());
            return extractArray(data);
        },
        staleTime: 5 * 60 * 1000,  // 5 min
        enabled,
    });
}

export default useAccounts;
